import { routerActions } from 'react-router-redux';
import { connectedReduxRedirect } from 'redux-auth-wrapper/history3/redirect';
import { isEmpty, get } from 'lodash';
import {
  permissions as perms,
  util as permissionUtil
} from 'functional-permissions-lib';

import { userCompletedDevSignup } from 'modules/user';

// todo: middleware that watches for 401s and re-checks userIsLoggedIn if it sees
// one, then base authSelector on that.

export const EnsureUserIsAuthenticated = connectedReduxRedirect({
  authenticatedSelector: state => !isEmpty(state.user.user),
  authenticatingSelector: state =>
    state.user.isLoggingIn || state.user.isFetching,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsAuthenticated',
  redirectPath: (state, ownProps) => {
    // using veritone login instead of developer login page
    if (
      state.user.isLoggingIn ||
      state.user.isFetching ||
      !isEmpty(state.user.user)
    ) {
      // hacking around the library call this function a lot even in case we don't redirect
      return '';
    }
    const loginRoute = get(state, 'config.pageUris.loginPageUri');
    const developerRoute = get(state, 'config.pageUris.developerPageUri');
    const currentPath = get(ownProps, 'location.pathname');
    if (currentPath === '/no-access') {
      // redirect to home page when current path is no-access
      return window.location.replace(
        `${loginRoute}?redirect=${developerRoute}`
      );
    }
    return window.location.replace(
      `${loginRoute}?redirect=${window.location.href}`
    );
  },
  // no access -> logout -> login as dev user should not redir to no-access
  allowRedirectBack: ({ pathname }) => pathname !== '/no-access'
});

export const EnsureUserCompletedDevSignup = connectedReduxRedirect({
  authenticatedSelector: state => {
    const userState = state.user;

    if (
      !permissionUtil.hasAccessTo(
        perms.developer.access,
        userState.user.permissionMasks
      )
    ) {
      // ignore for users who don't have app permissions
      return true;
    }

    // redirect if user hasn't completed signup
    return userCompletedDevSignup(userState);
  },
  redirectPath: '/onboarding/profile',
  redirectAction: routerActions.replace,
  allowRedirectBack: false,
  wrapperDisplayName: 'EnsureUserCompletedDevSignup'
});

export const RedirectIfLoggedIn = connectedReduxRedirect({
  authenticatedSelector: state => isEmpty(state.user.user),
  // redirect the user when they are done loading and authenticated
  authenticatingSelector: state =>
    state.user.isLoggingIn || state.user.isFetching,
  redirectPath: (state, ownProps) => ownProps.location.query.redirect || '/',
  allowRedirectBack: false,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'RedirectIfLoggedIn'
});



// WEBPACK FOOTER //
// ./src/client/helpers/auth.js